import { inject, injectable } from 'inversify';

import { UserHookService } from '../../application/User.hook.service';
import { TUseUserCreator } from '../../domain/interfaces';

@injectable()
export class UserHookController {
  constructor(
    @inject(UserHookService)
    private readonly userHookService: UserHookService,
  ) {}

  public composeUseUserCreator(): TUseUserCreator {
    return this.userHookService.composeUseUserCreator();
  }
}
